var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#00A050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30293 10.78C6.66845 10.4247 7.23602 10.4049 7.62398 10.7154L7.71701 10.7999L11.055 14.234L11.0556 3.99702C11.0556 3.44473 11.5033 2.99702 12.0556 2.99702C12.5684 2.99702 12.9911 3.38306 13.0488 3.8804L13.0556 3.99702L13.055 14.234L16.3941 10.7999C16.7495 10.4344 17.3163 10.3987 17.7128 10.6982L17.8082 10.78C18.1737 11.1354 18.2094 11.7022 17.91 12.0987L17.8281 12.1941L12.7726 17.3941C12.7322 17.435 12.6913 17.4707 12.6485 17.5023L12.5626 17.5592L12.4518 17.6155L12.3801 17.6432L12.2854 17.6705L12.215 17.6843L12.1142 17.6953L11.9969 17.6953L11.8771 17.6811L11.7938 17.6624L11.6848 17.626L11.6317 17.6031L11.5435 17.5562L11.4335 17.4801L11.3764 17.431L11.3386 17.3941L6.28301 12.1941C5.89802 11.7981 5.90694 11.165 6.30293 10.78Z",
    fill: "#00A050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGreen);
export default __webpack_public_path__ + "static/media/download-green.11f5145bea491b6aee7267d1914b90a7.svg";
export { ForwardRef as ReactComponent };